import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Thin wrapper over React Query for GET endpoints. Returns the standard query
 * object; `data` is the response body. Auth failures surface as errors (the
 * axios interceptor separately broadcasts vtx:auth-expired for the redirect),
 * so pages don't need their own try/catch just to avoid hanging.
 *
 *   const { data, isPending, isError } = useApiQuery("shipments", "/v1/shipments");
 */
export function useApiQuery(queryKey, path, options = {}) {
  return useQuery({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
    queryFn: async () => (await api.get(path)).data,
    retry: 1,
    ...options,
  });
}
